document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let ticking = false;

  addEventListener('scroll', () => {
    if (ticking) return;
    requestAnimationFrame(() => {
      root.style.setProperty('--hero-shift', `${Math.min(scrollY * 0.055, 42)}px`);
      ticking = false;
    });
    ticking = true;
  }, { passive: true });

  if (!reduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('reveal');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));
  }

  document.querySelectorAll('[data-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const main = document.querySelector('[data-main-image]');
      if (main) {
        main.src = button.dataset.image;
        main.alt = button.dataset.alt || '';
      }
      document.querySelectorAll('[data-thumb]').forEach((thumbnail) => thumbnail.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  const variant = document.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const formId = document.querySelector('[data-variant-id]');
  const buy = document.querySelector('[data-buy-button]');
  const availability = document.querySelector('[data-product-availability]');
  const availabilityText = availability?.querySelector('[data-availability-text]');

  variant?.addEventListener('change', () => {
    const option = variant.selectedOptions[0];
    const isAvailable = option.dataset.available === 'true';
    if (formId) formId.value = option.value;
    if (price) price.textContent = option.dataset.price;
    if (buy) {
      buy.disabled = !isAvailable;
      buy.textContent = isAvailable ? (buy.dataset.availableLabel || 'Add to cart') : (buy.dataset.soldOutLabel || 'Sold out');
    }
    if (availability) availability.classList.toggle('is-unavailable', !isAvailable);
    if (availabilityText && availability) availabilityText.textContent = isAvailable ? (availability.dataset.availableLabel || 'Available') : (availability.dataset.soldOutLabel || 'Sold out');
    if (option.dataset.image) {
      const main = document.querySelector('[data-main-image]');
      if (main) main.src = option.dataset.image;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const lightbox = document.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
  const lightboxStage = lightbox?.querySelector('[data-lightbox-stage]');
  const lightboxCount = lightbox?.querySelector('[data-lightbox-count]');
  const lightboxZoomLevel = lightbox?.querySelector('[data-lightbox-zoom-level]');
  const thumbnails = [...document.querySelectorAll('[data-thumb]')];
  let lightboxIndex = 0;
  let lightboxScale = 1;
  let lightboxPanX = 0;
  let lightboxPanY = 0;
  let dragStartX = 0;
  let dragStartY = 0;
  let dragOriginX = 0;
  let dragOriginY = 0;
  let pointerMoved = false;
  const activePointers = new Map();
  let pinchStartDistance = 0;
  let pinchStartScale = 1;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const applyLightboxTransform = () => {
    if (!lightboxImage || !lightboxStage) return;
    const maxPanX = lightboxStage.clientWidth * (lightboxScale - 1) / 2;
    const maxPanY = lightboxStage.clientHeight * (lightboxScale - 1) / 2;
    lightboxPanX = clamp(lightboxPanX, -maxPanX, maxPanX);
    lightboxPanY = clamp(lightboxPanY, -maxPanY, maxPanY);
    lightboxImage.style.transform = `translate3d(${lightboxPanX}px, ${lightboxPanY}px, 0) scale(${lightboxScale})`;
    lightboxStage.classList.toggle('is-zoomed', lightboxScale > 1);
    if (lightboxZoomLevel) lightboxZoomLevel.textContent = `${Math.round(lightboxScale * 100)}%`;
  };

  const setLightboxZoom = (scale) => {
    lightboxScale = clamp(scale, 1, 4);
    if (lightboxScale === 1) {
      lightboxPanX = 0;
      lightboxPanY = 0;
    }
    applyLightboxTransform();
  };

  const resetLightboxZoom = () => {
    lightboxScale = 1;
    lightboxPanX = 0;
    lightboxPanY = 0;
    activePointers.clear();
    applyLightboxTransform();
  };

  const renderLightbox = () => {
    const thumbnail = thumbnails[lightboxIndex];
    if (!thumbnail || !lightboxImage) return;
    resetLightboxZoom();
    lightboxImage.src = thumbnail.dataset.image;
    lightboxImage.alt = thumbnail.dataset.alt || '';
    if (lightboxCount) lightboxCount.textContent = `${lightboxIndex + 1} / ${thumbnails.length}`;
  };

  const openLightbox = () => {
    const activeThumbnail = document.querySelector('[data-thumb].is-active');
    lightboxIndex = Math.max(0, thumbnails.indexOf(activeThumbnail));
    renderLightbox();
    if (typeof lightbox?.showModal === 'function') lightbox.showModal();
    else lightbox?.setAttribute('open', '');
    lightbox?.querySelector('[data-lightbox-close]')?.focus();
  };

  document.querySelector('[data-gallery-open]')?.addEventListener('click', openLightbox);
  lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => {
    resetLightboxZoom();
    lightbox.close();
  });
  lightbox?.querySelector('[data-lightbox-zoom-in]')?.addEventListener('click', () => setLightboxZoom(lightboxScale + 0.5));
  lightbox?.querySelector('[data-lightbox-zoom-out]')?.addEventListener('click', () => setLightboxZoom(lightboxScale - 0.5));
  lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => {
    lightboxIndex = (lightboxIndex - 1 + thumbnails.length) % thumbnails.length;
    renderLightbox();
  });
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => {
    lightboxIndex = (lightboxIndex + 1) % thumbnails.length;
    renderLightbox();
  });
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) lightbox.close();
  });

  lightboxStage?.addEventListener('dblclick', () => {
    setLightboxZoom(lightboxScale > 1 ? 1 : 2);
  });

  lightboxStage?.addEventListener('wheel', (event) => {
    event.preventDefault();
    setLightboxZoom(lightboxScale + (event.deltaY < 0 ? 0.25 : -0.25));
  }, { passive: false });

  lightboxStage?.addEventListener('pointerdown', (event) => {
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    lightboxStage.setPointerCapture?.(event.pointerId);
    pointerMoved = false;
    if (activePointers.size === 2) {
      const [first, second] = [...activePointers.values()];
      pinchStartDistance = Math.hypot(second.x - first.x, second.y - first.y);
      pinchStartScale = lightboxScale;
      return;
    }
    dragStartX = event.clientX;
    dragStartY = event.clientY;
    dragOriginX = lightboxPanX;
    dragOriginY = lightboxPanY;
  });

  lightboxStage?.addEventListener('pointermove', (event) => {
    if (!activePointers.has(event.pointerId)) return;
    activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    if (activePointers.size === 2) {
      const [first, second] = [...activePointers.values()];
      const distance = Math.hypot(second.x - first.x, second.y - first.y);
      if (pinchStartDistance) setLightboxZoom(pinchStartScale * distance / pinchStartDistance);
      pointerMoved = true;
      return;
    }
    if (lightboxScale <= 1) return;
    if (Math.hypot(event.clientX - dragStartX, event.clientY - dragStartY) > 4) pointerMoved = true;
    lightboxPanX = dragOriginX + event.clientX - dragStartX;
    lightboxPanY = dragOriginY + event.clientY - dragStartY;
    applyLightboxTransform();
  });

  const releaseLightboxPointer = (event) => {
    activePointers.delete(event.pointerId);
    if (activePointers.size < 2) pinchStartDistance = 0;
    if (!activePointers.size && !pointerMoved && lightboxScale === 1) setLightboxZoom(2);
  };
  lightboxStage?.addEventListener('pointerup', releaseLightboxPointer);
  lightboxStage?.addEventListener('pointercancel', releaseLightboxPointer);

  document.querySelectorAll('[data-related-products]').forEach(async (element) => {
    if (!element.dataset.url || !element.hidden) return;
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const incoming = html.querySelector('[data-related-products]');
      if (!incoming?.innerHTML.trim()) return;
      element.innerHTML = incoming.innerHTML;
      element.hidden = false;
    } catch (error) {
      element.hidden = true;
    }
  });

  document.querySelectorAll('[data-recently-viewed]').forEach(async (element) => {
    const currentHandle = element.dataset.currentHandle;
    const sectionId = element.dataset.sectionId;
    const grid = element.querySelector('[data-recently-viewed-grid]');
    if (!currentHandle || !sectionId || !grid) return;

    const storageKey = 'scf-recently-viewed';
    let storedHandles = [];
    try {
      storedHandles = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(storedHandles)) storedHandles = [];
    } catch (error) {
      storedHandles = [];
    }

    const savedHandles = [...new Set(storedHandles)]
      .filter((handle) => typeof handle === 'string' && handle.trim());
    const previousHandles = savedHandles
      .filter((handle) => handle !== currentHandle)
      .slice(0, 4);
    const invalidHandles = new Set();

    const cards = await Promise.all(previousHandles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`);
        if (!response.ok) {
          if (response.status === 404 || response.status === 410) invalidHandles.add(handle);
          return null;
        }
        const container = document.createElement('div');
        container.innerHTML = await response.text();
        const template = container.querySelector('[data-recent-product-template]');
        const card = template?.content.querySelector('[data-recent-product-card]')?.firstElementChild;
        const title = card?.querySelector('h3')?.textContent.trim();
        const href = card?.querySelector('.product-card-link')?.getAttribute('href')?.trim();
        if (!title || !href) {
          invalidHandles.add(handle);
          return null;
        }
        const productUrl = new URL(href, window.location.origin);
        const linkedHandle = decodeURIComponent(productUrl.pathname.split('/products/')[1] || '').replace(/\/$/, '');
        if (productUrl.origin !== window.location.origin || linkedHandle !== handle || linkedHandle === currentHandle) {
          invalidHandles.add(handle);
          return null;
        }
        return card;
      } catch (error) {
        return null;
      }
    }));

    cards.filter(Boolean).forEach((card) => grid.appendChild(card));
    element.hidden = grid.children.length === 0;

    try {
      const validHistory = savedHandles.filter((handle) => handle !== currentHandle && !invalidHandles.has(handle));
      localStorage.setItem(storageKey, JSON.stringify([currentHandle, ...validHistory].slice(0, 8)));
    } catch (error) {
      /* Browsing can continue when storage is unavailable. */
    }
  });
});

